import { ApplicationConfig, importProvidersFrom, provideAppInitializer } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DatePipe, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCaptchaModule } from 'ngx-captcha';

import { routes } from './app.routes';
import { CommonInterceptor } from './core/interceptors/common.interceptor';
import { AuthErrorInterceptor } from './core/interceptors/auth-error.interceptor';
import { FormSaveLoaderInterceptor } from './core/interceptors/form-save-loader.interceptor';
import { FormUpdateLoadingInterceptor } from './core/interceptors/form-update-loading.interceptor';
import { AmountInWordsPipe } from './shared/pipes/amount-in-words.pipe';
import { ledgerReducer } from './core/stores/ledger/ledger.reducer';
import { LedgerEffects } from './core/stores/ledger/ledger.effects';
import { itemReducer } from './core/stores/item/item.reducer';
import { ItemEffects } from './core/stores/item/item.effects';
import { AppHammerConfig } from './core/config/app-hammer.config';
import { configureFigmaDatePickerBehavior } from './core/config/configure-datepicker-defaults';

import { providePrimeNG } from 'primeng/config';
import { ASquarePreset } from './theme/asquare-preset';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { MessageService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideAppInitializer(() => configureFigmaDatePickerBehavior()),
    providePrimeNG({
      theme: {
        preset: ASquarePreset,
      },
    }),
    importProvidersFrom(
      NgxCaptchaModule,
      FormsModule,
      ReactiveFormsModule,
      StoreModule.forRoot({ ledgers: ledgerReducer, items: itemReducer }),
      EffectsModule.forRoot([LedgerEffects, ItemEffects])
    ),
    { provide: HTTP_INTERCEPTORS, useClass: CommonInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: FormSaveLoaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: FormUpdateLoadingInterceptor, multi: true },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: HAMMER_GESTURE_CONFIG, useClass: AppHammerConfig },
    DatePipe,
    AmountInWordsPipe, provideIonicAngular({}),
    MessageService,
  ],
};
